import { FETCH_FAQS, ADD_FAQS, EDIT_FAQS, DELETE_FAQS, DESTROY_FAQS } from "../actionTypes";

export const fetchFaqs = faqs => ({
    type: FETCH_FAQS,
    faqs
});

export const addFaqs = faq => ({
    type: ADD_FAQS,
    faq
});

export const deleteFaqs = id => ({
    type: DELETE_FAQS,
    id
});

export const editFaqs = faq => ({
    type: EDIT_FAQS,
    faq
});

export const destroyFaqs = key => ({
    type: DESTROY_FAQS,
    key
})